module.exports = __webpack_public_path__ + "medal.73377b28.png";